import React, { memo } from 'react';
import Paper from '@mui/material/Paper';
import { makeStyles } from '@mui/styles';
import clsx from 'clsx';

import { Text, View } from '../Base';
import palette from '../styles/palette';

const useStyles = makeStyles(({ typography }) => ({
  root: {
    margin: '28px 125px 39px',
    background: palette.snackbarButtons.yellow,
    borderRadius: 0,
    padding: '14px 10px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  messageContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  message: {
    color: palette.typography.black.solid,
    fontSize: typography.pxToRem(14),
    fontWeight: 400,
    lineHeight: typography.pxToRem(20),
    letterSpacing: typography.pxToRem(-0.32),
  },
}));

const StaticBanner = ({
  message,
  MessageIcon,
  rootClassName,
  messageClassName,
  children,
}) => {
  const classes = useStyles();

  return (
    <Paper className={clsx(classes.root, rootClassName)} elevation={5}>
      <View className={classes.messageContainer}>
        {!!MessageIcon && <MessageIcon />}
        <Text
          className={clsx(classes.message, messageClassName)}
          component="h4"
        >
          {message}
        </Text>
      </View>
      {children}
    </Paper>
  );
};

export default memo(StaticBanner);
